// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Outlet } from 'react-router-dom';
import TopBanner from './TopBanner';

export default function AdminLayout() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <TopBanner />
      <main
        id="main-content"
        style={{
          paddingTop: '64px', // Offset for fixed banner
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
